import * as actionTypes from '../types/responsiblePerson';

const initialState = {
  loading: false,
  listPersonsOnStock: [],
  visibleMobileResponsiblePersonsOnSpock: false,
  loadedMobileResponsiblePersonsOnSpock: false,
  visibleMobileEditResponsiblePersonsOnSpock: false,
  loadedMobileEditResponsiblePersonsOnSpock: false,

  loadingAdd: false,

  loadingDel: false,
  isRestDelOk: false,

  listResponsiblePersons: [],

  saveLoading: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK:
      return {
        ...state,
        loading: true,
        isRestDelOk: false
      };
    case actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        listPersonsOnStock: payload
      };
    case actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.MODAL_RESPONSIBLE_PERSONS_ON_STOCK_OPEN:
      return {
        ...state,
        visibleMobileResponsiblePersonsOnSpock: true,
        loadedMobileResponsiblePersonsOnSpock: true
      };
    case actionTypes.MODAL_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE:
      return {
        ...state,
        visibleMobileResponsiblePersonsOnSpock: false
      };

    case actionTypes.MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_OPEN:
      return {
        ...state,
        visibleMobileEditResponsiblePersonsOnSpock: true,
        loadedMobileEditResponsiblePersonsOnSpock: true
      };
    case actionTypes.MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE:
      return {
        ...state,
        visibleMobileEditResponsiblePersonsOnSpock: false
      };

    case actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK:
      return {
        ...state,
        loadingAdd: true
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        visibleMobileResponsiblePersonsOnSpock: false
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK_FAIL:
      return {
        ...state,
        loadingAdd: false
      };

    case actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK:
      return {
        ...state,
        loadingDel: true,
        isRestDelOk: false
      };
    case actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS:
      return {
        ...state,
        loadingDel: false,
        isRestDelOk: true
      };
    case actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK_FAIL:
      return {
        ...state,
        loadingDel: false,
        isRestDelOk: false
      };

    case actionTypes.GET_LIST_RESPONSIBLE_PERSONS:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_LIST_RESPONSIBLE_PERSONS_SUCCESS:
      return {
        ...state,
        loading: false,
        listResponsiblePersons: payload
      };
    case actionTypes.GET_LIST_RESPONSIBLE_PERSONS_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.ADD_RESPONSIBLE_PERSON:
      return {
        ...state,
        loading: true
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.DEL_RESPONSIBLE_PERSON:
      return {
        ...state,
        loadingDel: true,
        isRestDelOk: false
      };
    case actionTypes.DEL_RESPONSIBLE_PERSON_SUCCESS:
      return {
        ...state,
        loadingDel: false,
        isRestDelOk: true
      };
    case actionTypes.DEL_RESPONSIBLE_PERSON_FAIL:
      return {
        ...state,
        loadingDel: false,
        isRestDelOk: false
      };
    default:
      return state;
  }
};

export default reducer;
